import { AccountInfo } from './AccountInfo';
import { connect } from 'react-redux';
import { accountViewActions } from 'src/store/modules/accountview';
import { userDataSel } from 'src/store/modules/user';
import { withI18n } from 'react-i18next';

const mapStateToProps = (state: any) => {
  return {
    userData: userDataSel(state)
  };
};

// const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
//   onSelect: (selected: string) => dispatch(accountViewActions.setMenuOption(selected))
// });

export const pureComponent = AccountInfo;
export default connect(mapStateToProps, null)(withI18n()(AccountInfo));

// interface IDispatchFromProps {
//   onSelect(selected: string): void;
// }
